import { z } from 'zod'

/**
 * Deferral raised at screening off an abnormal body temperature. There is no
 * examination behind it, so the reason is what justifies the deferral and is
 * required.
 */
export const temperatureDeferralSchema = (t: (key: string) => string) =>
  z.object({
    reason: z
      .string()
      .trim()
      .min(1, t('donor_detail.screening.temperature_deferral.reason_required')),
    deferral_end_date: z
      .string()
      .min(1, t('donor_detail.screening.temperature_deferral.date_required')),
  })

export type TemperatureDeferralFormValues = z.infer<
  ReturnType<typeof temperatureDeferralSchema>
>
